<template lang="pug">
    include SportsFacilities.pug
</template>

<script>
import _ from "underscore"
import { mapState } from 'vuex'
import Slick from 'vue-slick'
import Api from './../services/Api'
import StaticMap from 'vue-static-map'

export default {
  name: 'SportsFacilities',
  props: ["slug"],
  components: {Slick, StaticMap},
  computed: mapState([
    "context",
  ]),
  data() {
    // Data contained on the component
    return {
      apiKey: "AIzaSyDfENvdf9388k3BjTOTzC0ilk4HpujRqPY",
      slickOptions: {},
      facility: null,
      zoom: 13,
    };
  },
  created() {
    const _this = this
    Api.facility(this.slug).then(response => {
      let facilities = response.data.items
      let facility = _.first(facilities)
      _this.facility = facility
    })
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";

@import '../Trainer';
@import "SportsFacilities";

</style>



// WEBPACK FOOTER //
// src/components/sports_facilities/SportsFacilities.vue